import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/questions/multiple-choice`;

export const multipleChoiceQuestionsRoutesObj = {
  create: `${baseRoute}/create/:courseId/:examId/`,
  edit: `${baseRoute}/edit/:courseId/:examId/:questionId`,
  view: `${baseRoute}/view/:courseId/:examId/:questionId`,
} as const;

export type IMultipleChoiceQuestionsRouteParams = IExtractRouteParamMap<
  typeof multipleChoiceQuestionsRoutesObj
>;

export const multipleChoiceQuestionPath = createPaths<
  typeof multipleChoiceQuestionsRoutesObj,
  IMultipleChoiceQuestionsRouteParams
>(multipleChoiceQuestionsRoutesObj);
